import {
  Alert,
  AlertIcon,
  Box,
  Image,
  Center,
  CloseButton,
  Heading,
  Spinner,
  Text,
  Flex,
} from "@chakra-ui/react";
import moment from "moment";
import React, { useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import BottomSheetWrapper from "../../components/BottomSheetWrapper";
import { useEvent, useEventLocation } from "../../data/events.api";
import { useFocusOnLngLat } from "../../hooks/useFocusOnLngLat";
import placeholderImg from "../../assets/event-placeholder.jpg";
import DirectionsButton from "../../components/search/DirectionsButton";
import HybridBottomSheetDrawer from "../../components/HybridBottomSheetDrawer";
import BackButton from "../../components/BackButton";
import FavouriteButton from "../../components/FavouriteButton";
import DirectionsButtonMazemap from "../../components/search/DirectionsButtonMazemap";

const ViewEvent = () => {
  const { eventId } = useParams<{ eventId: string }>();
  const { data, isLoading, isError } = useEvent(eventId ?? "");
  const { data: locationData } = useEventLocation(data);

  useFocusOnLngLat(
    locationData?.Longitude ? parseFloat(locationData.Longitude) : undefined,
    locationData?.Latitude ? parseFloat(locationData.Latitude) : undefined
  );

  const endDate = moment(data?.endDate);
  console.log("regular data -> ", data);
  console.log("locations data ->", locationData);

  return (
    <HybridBottomSheetDrawer>
      {isLoading ? (
        <Center p={8}>
          <Spinner />
        </Center>
      ) : isError ? (
        <Center p={8}>
          <Alert status="error">
            <AlertIcon />
            Could not find a event with ID {eventId}
          </Alert>
        </Center>
      ) : data ? (
        <>
          <Image
            src={data?.imageLink ?? placeholderImg}
            objectFit="cover"
            h={48}
            w="full"
            role="img"
            bgSize="cover"
            bgPos={"center"}
          />
          <Box position="relative" p={10}>
            <BackButton />

            <Box mb={3}>
              <Flex justify="space-between">
                <Heading size="md">{data?.title}</Heading>
                <FavouriteButton name={data?.title} />
              </Flex>
              <Text opacity={0.7}>
                {moment(data?.startDate).format("DD/MM/YYYY HH:mm")} -{" "}
                {endDate.isValid()
                  ? endDate.format("DD/MM/YYYY HH:mm")
                  : data.endDate}
              </Text>
              <Text opacity={0.5}>{data?.location?.locationName}</Text>
            </Box>
            <Text mb={3}>{data?.shortDescription}</Text>
            {data.contact ? (
              <>
                <Heading size="sm" mb={2}>
                  Contact
                </Heading>
                {data.contact.name ? (
                  <Text>
                    <strong>Name:</strong> {data?.contact.name}
                  </Text>
                ) : null}
                {data.contact.email ? (
                  <Text>
                    <strong>Email:</strong> {data?.contact.email}
                  </Text>
                ) : null}
                {data.contact.phone ? (
                  <Text>
                    <strong>Phone:</strong> {data?.contact.phone}
                  </Text>
                ) : null}
              </>
            ) : null}
            {locationData ? (
              <DirectionsButtonMazemap plannonID={locationData.PlannonID} />
            ) : null}
          </Box>
        </>
      ) : null}
    </HybridBottomSheetDrawer>
  );
};

export default ViewEvent;
